

















































































































import Vue from 'vue'
import SlotCardBase from '../_SlotCardBase.vue'
import SystemSelector from './_SystemSelector.vue'
import EquipmentOptions from '../_EquipmentOptions.vue'
import { MechSystem } from '@/class'

export default Vue.extend({
  name: 'system-slot-card',
  components: {
    SlotCardBase,
    EquipmentOptions,
    SystemSelector,
  },
  props: {
    mech: {
      type: Object,
      required: true,
    },
    item: {
      type: Object,
      required: false,
      default: null,
    },
    index: {
      type: Number,
      required: false,
      default: -1,
    },
    color: {
      type: String,
      required: false,
      default: 'primary',
    },
    readonly: {
      type: Boolean,
    },
    empty: {
      type: Boolean,
    },
  },
  computed: {
    small() {
      return this.$vuetify.breakpoint.smAndDown
    },
  },
  methods: {
    equipExtra(sys: MechSystem) {
      this.mech.MechLoadoutController.ActiveLoadout.AddSystem(sys)
      this.$refs.selectorDialog.hide()
    },
    equip(sys: MechSystem) {
      if (this.item) {
        this.mech.MechLoadoutController.ActiveLoadout.ChangeSystem(this.index, sys)
      } else {
        this.mech.MechLoadoutController.ActiveLoadout.AddSystem(sys)
      }
      this.$refs.base.$refs.selectorDialog.hide()
    },
    remove(sys: MechSystem) {
      this.mech.MechLoadoutController.ActiveLoadout.RemoveSystem(sys)
    },
  },
})
